var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNightMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Guide",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m497.139 291.079a7.955 7.955 0 0 0 -9.837 2.9 206.2 206.2 0 0 1 -173.135 90.951c-55.12-.455-106.666-22.053-145.144-60.814a203.685 203.685 0 0 1 5.723-292.736 8.012 8.012 0 0 0 -8.44-13.3 248.158 248.158 0 0 0 -113.071 90.186 246.145 246.145 0 0 0 30.28 314.794c46.813 46.069 109.046 71.44 175.232 71.44a250.283 250.283 0 0 0 157.1-55.5 247.629 247.629 0 0 0 85.963-138.863 7.909 7.909 0 0 0 -4.671-9.058zm-88.847 138.6a238.246 238.246 0 0 1 -149.545 52.821c-63.018 0-122.261-24.147-166.815-67.994a234.141 234.141 0 0 1 -28.811-299.437 236.089 236.089 0 0 1 88.738-77.364 215.841 215.841 0 0 0 8.648 294.862c40.721 41.021 95.257 63.878 153.56 64.36.617 0 1.226.008 1.842.008a218.123 218.123 0 0 0 168.911-79.57 236.207 236.207 0 0 1 -76.528 112.31z",
    fill: "#d1fae4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightMode);
export default __webpack_public_path__ + "static/media/night-mode.ed9f082d.svg";
export { ForwardRef as ReactComponent };